export const zhHK = {
  yes:'是',
  no:'否',
  }
